import { RootState, useAppSelector } from '@core/store';

import { SANDBOX_BANNER_HEIGHT, TRIAL_BANNER_HEIGHT } from '../constants';

// Height of the banners stacked above the header (sandbox, then trial mode),
// shared by everything that needs to sit below them: the header/sidebar,
// the dynamic banner carousel, and the page content.
const useTopBannersOffset = () => {
  const isTrialMode = useAppSelector(
    (state: RootState) => state.trial?.isTrialMode
  );
  const isSandBoxEnv = process.env.REACT_APP_ENVIRONMENT === 'sandbox';

  const sandboxOffset = isSandBoxEnv ? SANDBOX_BANNER_HEIGHT : 0;
  const trialBannerOffset = isTrialMode ? TRIAL_BANNER_HEIGHT : 0;

  return {
    sandboxOffset,
    trialBannerOffset,
    total: sandboxOffset + trialBannerOffset
  };
};

export default useTopBannersOffset;
